<template>
  <div class="page-main aging-page" v-loading="loading">
    <div class="aging-head">
      <div>
        <span class="aging-title">应收账龄</span>
        <span class="aging-sub">
          只统计已审核核算单；未收 = 合同应收 - 已审核收款（待审核收款不算已收）
        </span>
      </div>
      <div class="aging-actions">
        <el-button size="mini" plain @click="go('/finance/payin/list')">去开收款单（旧版）</el-button>
        <el-button size="mini" type="primary" plain @click="load">刷新</el-button>
      </div>
    </div>

    <!-- 筛选 -->
    <div class="aging-filter">
      <span class="filter-label">开单日期</span>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        size="mini"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
      />
      <span class="filter-label">账龄</span>
      <el-select v-model="minAge" size="mini" style="width: 120px">
        <el-option label="全部" value="" />
        <el-option label="超过 30 天" value="30" />
        <el-option label="超过 60 天" value="60" />
        <el-option label="超过 90 天" value="90" />
      </el-select>
      <span class="filter-label">客户</span>
      <el-input
        v-model="keyword"
        size="mini"
        placeholder="客户名称关键字"
        clearable
        style="width: 180px"
        @keyup.enter.native="search"
      />
      <el-button size="mini" type="primary" @click="search">查询</el-button>
      <el-button size="mini" @click="reset">重置</el-button>
    </div>

    <!-- 合计 -->
    <div class="aging-sum">
      <div class="sum-item">
        <span class="sum-label">客户数</span>
        <span class="sum-value">{{ total.row_cnt || 0 }}</span>
      </div>
      <div class="sum-item">
        <span class="sum-label">未清单据</span>
        <span class="sum-value">{{ total.bill_cnt || 0 }}</span>
      </div>
      <div class="sum-item">
        <span class="sum-label">合同应收</span>
        <span class="sum-value">{{ wan(total.total) }}</span>
      </div>
      <div class="sum-item">
        <span class="sum-label">已收</span>
        <span class="sum-value c-green">{{ wan(total.received) }}</span>
      </div>
      <div class="sum-item">
        <span class="sum-label">未收合计</span>
        <span class="sum-value c-blue">{{ wan(total.unpaid) }}</span>
      </div>
      <div class="sum-item">
        <span class="sum-label">90 天以上</span>
        <span class="sum-value c-red">{{ wan(total.age_90p) }}</span>
      </div>
    </div>

    <div class="aging-tip">
      账龄按「开单日期到今天」计算，系统没有合同账期字段；若客户是月结，请在催收时按合同日期再判断一次。
      客户名为空的历史单据统一归到「（未填客户）」，建议让商务补齐客户名。
    </div>

    <!-- 明细 -->
    <el-table
      :data="pageList"
      size="mini"
      border
      height="calc(100vh - 400px)"
      :header-cell-style="headStyle"
      show-summary
      :summary-method="summaryMethod"
    >
      <el-table-column type="index" label="#" width="45" align="center" fixed />
      <el-table-column prop="company_name" label="客户" min-width="220" show-overflow-tooltip fixed />
      <el-table-column prop="bill_cnt" label="未清单据" width="90" align="center" />
      <el-table-column label="合同应收" width="120" align="right">
        <template #default="{ row }">{{ wan(row.total) }}</template>
      </el-table-column>
      <el-table-column label="已收" width="110" align="right">
        <template #default="{ row }">{{ wan(row.received) }}</template>
      </el-table-column>
      <el-table-column label="未收" width="120" align="right">
        <template #default="{ row }">
          <span class="c-blue bold">{{ wan(row.unpaid) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="0-30 天" width="110" align="right">
        <template #default="{ row }">{{ wan(row.age_30) }}</template>
      </el-table-column>
      <el-table-column label="31-60 天" width="110" align="right">
        <template #default="{ row }">{{ wan(row.age_60) }}</template>
      </el-table-column>
      <el-table-column label="61-90 天" width="110" align="right">
        <template #default="{ row }">{{ wan(row.age_90) }}</template>
      </el-table-column>
      <el-table-column label="90 天以上" width="120" align="right">
        <template #default="{ row }">
          <span :class="Number(row.age_90p) > 0 ? 'c-red' : ''">{{ wan(row.age_90p) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="最长账龄" width="95" align="center">
        <template #default="{ row }">
          <span :class="ageClass(row.max_age)">{{ row.max_age }} 天</span>
        </template>
      </el-table-column>
      <el-table-column label="最近开单" width="110" align="center">
        <template #default="{ row }">{{ dateStr(row.last_bill_date) }}</template>
      </el-table-column>
    </el-table>

    <div class="aging-pager">
      <el-pagination
        background
        small
        layout="total, sizes, prev, pager, next"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="list.length"
        @current-change="pageChange"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dateRange: [],
      minAge: '',
      keyword: '',
      list: [],
      total: {},
      currentPage: 1,
      pageSize: 50
    }
  },
  computed: {
    pageList() {
      let start = (this.currentPage - 1) * this.pageSize
      return this.list.slice(start, start + this.pageSize)
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/finance/receivableAge',
        data: {
          startDate: this.dateRange && this.dateRange[0] ? this.dateRange[0] : '',
          endDate: this.dateRange && this.dateRange[1] ? this.dateRange[1] : '',
          minAge: this.minAge,
          keyword: this.keyword
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.list = res.data.list || []
            this.total = res.data.total || {}
            this.currentPage = 1
          } else {
            this.$message.error(res.data.msg || '查询失败')
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    search() {
      this.load()
    },
    reset() {
      this.dateRange = []
      this.minAge = ''
      this.keyword = ''
      this.load()
    },
    pageChange(page) {
      this.currentPage = page
    },
    sizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
    },
    go(path) {
      this.$router.push(path)
    },
    headStyle() {
      return { background: '#f5f7fa', color: '#606266', padding: '6px 0' }
    },
    summaryMethod({ columns }) {
      let total = this.total
      return columns.map((column, index) => {
        if (index === 0) return '合计'
        if (index === 1) return `共 ${total.row_cnt || 0} 个客户`
        if (column.property === 'bill_cnt') return total.bill_cnt || 0
        let fieldMap = {
          合同应收: total.total,
          已收: total.received,
          未收: total.unpaid,
          '0-30 天': total.age_30,
          '31-60 天': total.age_60,
          '61-90 天': total.age_90,
          '90 天以上': total.age_90p
        }
        if (Object.prototype.hasOwnProperty.call(fieldMap, column.label)) {
          return this.wan(fieldMap[column.label])
        }
        return ''
      })
    },
    wan(value) {
      let num = Number(value || 0)
      if (isNaN(num)) num = 0
      return (num / 10000).toFixed(2)
    },
    dateStr(value) {
      if (!value) return ''
      return String(value).slice(0, 10)
    },
    ageClass(age) {
      let n = Number(age || 0)
      if (n > 90) return 'c-red'
      if (n > 60) return 'c-orange'
      return 'c-gray'
    }
  }
}
</script>

<style lang="less" scoped>
.aging-page {
  padding: 10px 12px 12px;
  height: calc(100vh - 86px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.aging-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  .aging-title {
    font-size: 17px;
    font-weight: 600;
    margin-right: 10px;
  }
  .aging-sub {
    font-size: 12px;
    color: #909399;
  }
}
.aging-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 8px;
  .filter-label {
    font-size: 12px;
    color: #606266;
  }
}
.aging-sum {
  display: flex;
  flex-wrap: wrap;
  gap: 26px;
  background: #f8fafd;
  border: 1px solid #e4ebf7;
  border-radius: 4px;
  padding: 8px 14px;
  margin-bottom: 8px;
  .sum-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
    .sum-label {
      font-size: 12px;
      color: #909399;
    }
    .sum-value {
      font-size: 15px;
      font-weight: 600;
    }
  }
}
.aging-tip {
  font-size: 12px;
  color: #8a5a20;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 4px;
  padding: 6px 12px;
  margin-bottom: 8px;
  line-height: 20px;
}
.aging-pager {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}
.bold {
  font-weight: 600;
}
.c-blue {
  color: #396bf6;
}
.c-green {
  color: #46bd87;
}
.c-orange {
  color: #e6a23c;
}
.c-red {
  color: #f56c6c;
}
.c-gray {
  color: #909399;
}
</style>
